const NotFound = () => {
    return (
        'Page not found!'
    )
}

export default NotFound;